import { call, put } from 'redux-saga/effects';
import { api, showErrorNotification, showSuccessNotification } from '@med-fe/util';
import {
  fetchRampsSuccess,
  fetchRampsFailed,
  fetchAssignmentsSuccess,
  fetchAssignmentsFailed,
  saveRampSuccess,
  saveRampFailed,
} from './ramps-actions';
import {
  SAVE_RAMP,
  SAVE_ASSIGNMENT,
  saveAssignmentSuccess,
  saveAssignmentFailed,
  fetchAssignments,
} from './ramps-actions';
import { APPLY_ASSIGNMENT, applyAssignmentSuccess, applyAssignmentFailed } from './ramps-actions';
import { fetchRamps } from './ramps-actions';

export function* fetchRampsStartWorker(): Generator {
  try {
    const url = '/ramps';
    const data: any = yield call(api.get, url, true, false);
    yield put(fetchRampsSuccess(data));
  } catch (e: any) {
    yield put(fetchRampsFailed(e));
    showErrorNotification(e);
  }
}

export function* fetchAssignmentsStartWorker(action: any): Generator {
  try {
    const url = '/ramps/assignments/search';
    const body = action && action.payload ? action.payload : {};
    const data: any = yield call(api.post, url, body, null, true, false);
    // expected response shape: { contents: [...], pages: n, total: m }
    yield put(fetchAssignmentsSuccess(data || { contents: [], pages: 0, total: 0 }));
  } catch (e: any) {
    yield put(fetchAssignmentsFailed(e));
    showErrorNotification(e);
  }
}

export function* saveRampStartWorker({ payload }: any): Generator {
  try {
    const url = '/ramps/save';
    const data: any = yield call(api.post, url, payload, null, true, false);
    yield put(saveRampSuccess(data));
    // show success message for create or update
    const isUpdate = payload && (payload.rampId || payload.rampId === 0);
    showSuccessNotification(isUpdate ? 'Ramp definition updated successfully!' : 'Ramp definition saved successfully!');
    // refresh list after save
    yield put(fetchRamps());
  } catch (e: any) {
    yield put(saveRampFailed(e));
    showErrorNotification(
      e?.error?.messages && e.error.messages.length ? e.error.messages[0] : 'Failed to save ramp. Please try again.'
    );
  }
}

export function* saveAssignmentStartWorker({ payload }: any): Generator {
  try {
    const url = '/ramps/assignments/save';
    const data: any = yield call(api.post, url, payload, null, true, false);
    let rampAssignmentIds: number[] = [];
    if (Array.isArray(data) && data.length > 0 && data[0]) {
      rampAssignmentIds = [data[0]];
    } else if (data && data.rampAssignmentId) {
      rampAssignmentIds = [data.rampAssignmentId];
    }
    if (rampAssignmentIds.length > 0) {
      yield put({ type: APPLY_ASSIGNMENT, payload: { rampAssignmentIds } });
    }
    yield put(saveAssignmentSuccess(data));

    // refresh assignments after save
    yield put(fetchAssignments({ page: 1, size: 10, refreshCache: true }));
  } catch (e: any) {
    yield put(saveAssignmentFailed(e));
    showErrorNotification(
      e?.error?.messages && e.error.messages.length ? e.error.messages[0] : 'Failed to save ramp. Please try again.'
    );
  }
}

export function* applyAssignmentStartWorker({ payload }: any): Generator {
  try {
    const url = '/ramps/assignments/apply';
    const data: any = yield call(api.post, url, payload, null, true, false);
    yield put(applyAssignmentSuccess(data));
    showSuccessNotification('Ramp assignment saved and applied successfully!');
    // refresh assignments after apply
    yield put(fetchAssignments({ page: 1, size: 10, refreshCache: true }));
  } catch (e: any) {
    yield put(applyAssignmentFailed(e));
    showErrorNotification(
      e?.error?.messages && e.error.messages.length ? e.error.messages[0] : 'Failed to apply ramp. Please try again.'
    );
  }
}

export function* deleteAssignmentStartWorker({ payload }: any): Generator {
  try {
    const { rampAssignmentId } = payload;
    const url = `/ramps/assignments/${rampAssignmentId}`;
    const data: any = yield call(api.delete, url, null, true, false);
    const { deleteAssignmentSuccess } = yield import('./ramps-actions');
    yield put(deleteAssignmentSuccess(data));
    showSuccessNotification('Ramp assignment deleted successfully!');
    // refresh assignments after delete
    yield put(fetchAssignments({ page: 1, size: 10, refreshCache: true }));
  } catch (e: any) {
    const { deleteAssignmentFailed } = yield import('./ramps-actions');
    yield put(deleteAssignmentFailed(e));
    showErrorNotification(
      e?.error?.messages && e.error.messages.length
        ? e.error.messages[0]
        : 'Failed to delete ramp assignment. Please try again.'
    );
  }
}
